export default __webpack_public_path__ + "static/media/rabbit22.e838d784.gif";